module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f7f46bfccd0339b382ebdc84d8245b1a.png";